export const camelCaseToKebab = (widgetDiv: HTMLDivElement, props: object) => {
	// loop through entries of object and convert each entry into a
	// property for the widget
	Object.entries(props).forEach(([key, value]) => {
		widgetDiv.setAttribute(
			`data-sr-${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`,
			value,
		);
	});
};
